import dayjs from 'dayjs';
import { SalvFieldHeader } from '@salvapp/ui-components';
import FormattedDateTime from '../../../common/datetime/FormattedDateTime';
import React from 'react';
import { VersionTestModalFormValues } from './ScenarioVersionTestModal';
import { DATE_TIME_FORMAT, FULL_DATE_TIME_FORMAT } from '../../../common/helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { InternalApiScenarioContentTestResultInformation, InternalApiScenarioTestResult } from '../../../api-internal';

export const generatePeriodicStartTimes = (values: VersionTestModalFormValues) => {
  const startTimes = [];
  const interval = values.periodicScenarioInterval;
  const timeUnit = values.periodicScenarioTimeUnit;
  const from = dayjs(values.dateTimeFrom, DATE_TIME_FORMAT);
  const to = dayjs(values.dateTimeTo, DATE_TIME_FORMAT);

  for (let i = 0; from.add(i * interval, timeUnit.toLowerCase() as dayjs.ManipulateType).isBefore(to); i++) {
    startTimes.push(from.add(i * interval, timeUnit.toLowerCase() as dayjs.ManipulateType).format('YYYY-MM-DD HH:mm'));
  }
  // Get the first two elements and last two elements from the array when there are more than 4 elements
  const visibleStartTimes =
    startTimes.length > 4
      ? [startTimes[0], startTimes[1], null, startTimes[startTimes.length - 2], startTimes[startTimes.length - 1]]
      : startTimes;
  return (
    <div>
      <SalvFieldHeader label={`Planned test start times (${startTimes.length})`} />
      <div>
        {visibleStartTimes.map((time) => (
          <div key={time} className='m-t-8'>
            {time ? <FormattedDateTime date={new Date(time)} showTime /> : '...'}
          </div>
        ))}
      </div>
    </div>
  );
};

export const renderSampleTimeRange = (
  testResult: InternalApiScenarioContentTestResultInformation | InternalApiScenarioTestResult
) => {
  return (
    <div>
      <span>{dayjs(testResult.testDataTimeFrom).format(FULL_DATE_TIME_FORMAT)}</span>
      <FontAwesomeIcon icon={faArrowRight} className='m-x-8' />
      <span>{dayjs(testResult.testDataTimeTo).format(FULL_DATE_TIME_FORMAT)}</span>
    </div>
  );
};
